import { backgroundCheckTypeChanges } from '@/backend/features/background-check/utils/backgroundCheckTypeChanges';
import { triggerRecalculateBackgroundCheckStatus } from '@/backend/features/background-check/utils/triggerRecalculateBackgroundCheckStatus';
import { defineSettingMap } from '@juvare/platform-sdk-react/backend/features/editable-settings/shared';
import {
    backgroundCheckQuotaForm,
    backgroundCheckTestForm,
    defaultBackgroundCheckConfig,
    defaultBackgroundCheckQuota,
    defaultBackgroundCheckTest,
} from './defaults';

export const backgroundCheckSettingMap = defineSettingMap({
    backgroundCheckConfig: {
        type: 'json',
        description: 'Background Check Config',
        defaultValue: defaultBackgroundCheckConfig,
        group: 'system-admin',
        onScheduleChangedAsync: (_context, params) => {
            if (params.action === 'update') {
                const { previousBackgroundCheckType, newBackgroundCheckType } = backgroundCheckTypeChanges(params.prevData, params.data);

                if (previousBackgroundCheckType === 'manual' || newBackgroundCheckType === 'manual') {
                    return true;
                }
            }

            return false;
        },
        onChangedAsync: (context, params) => {
            if (params.action === 'update') {
                const { previousBackgroundCheckType, newBackgroundCheckType } = backgroundCheckTypeChanges(params.prevData, params.data);

                if (
                    previousBackgroundCheckType &&
                    newBackgroundCheckType &&
                    (previousBackgroundCheckType === 'manual' || newBackgroundCheckType === 'manual')
                ) {
                    triggerRecalculateBackgroundCheckStatus(context, previousBackgroundCheckType, newBackgroundCheckType);
                }
            }
        },
    },
    backgroundCheckQuota: {
        type: 'json',
        description: 'Background Check Quota',
        defaultValue: defaultBackgroundCheckQuota,
        group: 'system-admin',
        form: backgroundCheckQuotaForm,
    },
    backgroundCheckTest: {
        type: 'json',
        description: 'Background Check Test',
        defaultValue: defaultBackgroundCheckTest,
        group: 'system-admin',
        form: backgroundCheckTestForm,
    },
});

export type BackgroundCheckSettingMapType = typeof backgroundCheckSettingMap;
